<template lang="pug">
  .HelperPanel
    div(v-if="type === 'layer-color-link'")
      span Слой использует связанную окраску.&#32;
      b Нажмите&#32;
      i.Icon.IconLinked
      span &#32;для отключения связи;&#32;
      i.Icon.IconColorSettings
      span &#32;для настройки связанных окрасок.
    div(v-else-if="type === 'layer-color-unlink'")
      span Слой использует связанную окраску.&#32;
      b Нажмите&#32;
      i.Icon.IconUnlinked
      span &#32;для включения связи;&#32;
      i.Icon.IconColorSettings
      span &#32;для настройки связанных окрасок.
    div(v-else-if="type === 'binding-distance-active'")
      span Привязка с фиксированными удельными затратами и плечом.&#32;
      b Нажмите&#32;
      span &#32;для изменения&#32;
    div(v-else-if="type === 'binding-distance-inactive'")
      b Нажмите
      span , чтобы добавить фиксированные удельные затраты и плечо
    div(v-else)
      | {{type}}

</template>

<script>
  export default {
    name: 'helper-panel',
    props: {
      type: {
        type: String,
        default: ''
      },
    },
  }
</script>
<style lang="scss">
  @import '~base';

  #app .LayoutPanel {
    --helperPanelText: #{$black5};
    --helperPanelBorder: #{$grey3};
  }

  #app[data-theme='dark'] .HelperPanel {
    --helperPanelText: #{$grey1};
    --helperPanelBorder: #{$grey2};
  }
</style>
<style scoped lang="scss">
  @import '~base';

  .HelperPanel {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 5px 15px;
    border-top: 2px solid var(--delimiter);
    background: var(--appBg);
    color: var(--helperPanelText);
    z-index: 12000;
    font-size: 11px;
    line-height: 1.5;

    .Icon {
      display: inline-block;
      vertical-align: middle;
      font-size: 12px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/HelperPanel.vue